package com.ijoin.data.repository

import com.ijoin.data.api.PushTokenApi
import com.ijoin.data.model.PushPlatform

class PushTokenRepository(
    private val api: PushTokenApi = PushTokenApi(),
) {
    suspend fun registerToken(token: String, platform: PushPlatform, deviceName: String? = null): Result<Unit> {
        return api.registerToken(token, platform, deviceName)
    }

    suspend fun deleteToken(token: String): Result<Unit> = api.deleteToken(token)
}
